import { fetchCreateRealty, ICreateRealtyRequest } from '../../repositories/price-estimator/v2/create-realty';
import { IApplicationContext } from '../../types/applicationContext';
import { createSubmitFlatDataMapper } from './mappers';

export const fetchFlatData = async (parameters: ICreateRealtyRequest, context: IApplicationContext) => {
  try {
    const res = await fetchCreateRealty({
      parameters,
      httpApi: context.httpApi,
      mappers: createSubmitFlatDataMapper(),
    });

    if (res instanceof Error) {
      throw res;
    }

    return res;
  } catch (error) {
    context.logger.error(error, { message: 'error in fetchCreateRealty' });

    throw error;
  }
};
